import PageImage from '../../common/component/PageImage';
import useValidVideoSources from '../../common/hook/useValidVideoSources';
import {EVENT_TOP_GRADIENT_BOX_CN, EVENT_TOP_HEIGHT_CN} from '../common';
import {ITopModuleV4} from '../type';

export interface IProps
  extends Pick<
    ITopModuleV4,
    'bgColor' | 'bgColorRgb' | 'bgImg' | 'thumbImg' | 'videoSources'
  > {}

export default function TopModuleBackgroundV4({
  bgColor,
  bgColorRgb,
  bgImg,
  thumbImg,
  videoSources,
}: IProps) {
  const sources = useValidVideoSources(videoSources);
  const hasVideo = !!(sources && sources.length > 0);
  return (
    <>
      {bgImg && (
        <PageImage src={bgImg} className={BG_CN} isLazy={false} alt="" />
      )}
      {thumbImg && !hasVideo && (
        <PageImage src={thumbImg} className={THUMB_CN} isLazy={false} alt="" />
      )}
      {hasVideo && (
        <video
          autoPlay
          playsInline
          muted
          disableRemotePlayback
          loop
          poster={thumbImg}
          className={THUMB_CN}
        >
          {sources.map(source => (
            <source key={source.src} src={source.src} type={source.type} />
          ))}
        </video>
      )}
      <div
        className={EVENT_TOP_GRADIENT_BOX_CN}
        style={{
          backgroundImage: `linear-gradient(
            180deg,
            rgba(${bgColorRgb}, 0) 0%,
            rgba(${bgColorRgb}, 0.7) 32.29%,
            ${bgColor} 65.62%,
            ${bgColor} 100%
          )`,
        }}
        data-testid="gradient-box"
      />
    </>
  );
}

const IMG_CN = cn(
  'absolute top-0',
  'left-1/2 -translate-x-1/2',
  'object-contain object-[top_center]'
);
const THUMB_CN = cn(IMG_CN, EVENT_TOP_HEIGHT_CN, 'w-[654px]');
const BG_CN = cn(IMG_CN, 'w-full -top-50');
